import {
  SUBSCRIPTION_REQUEST,
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_FAILURE
} from 'constants/Subscription'

export const subscriptionRequest = payload => ({ payload, type: SUBSCRIPTION_REQUEST })
export const subscriptionSuccess = payload => ({ payload, type: SUBSCRIPTION_SUCCESS })
export const subscriptionFailure = payload => ({ payload, type: SUBSCRIPTION_FAILURE })
